/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerChatLoader_viewer = {
    readonly pdpChatFeatureFlag: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"BuyerChatLazy_viewer" | "PdpRespDealerChatLazy_viewer">;
    readonly " $refType": "PdpRespDealerChatLoader_viewer";
};
export type PdpRespDealerChatLoader_viewer$data = PdpRespDealerChatLoader_viewer;
export type PdpRespDealerChatLoader_viewer$key = {
    readonly " $data"?: PdpRespDealerChatLoader_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerChatLoader_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespDealerChatLoader_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isInteractivePdpChat",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "pdpChatFeatureFlag",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "pdpChat"
        }
      ],
      "storageKey": "isEnabled(key:\"pdpChat\")"
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isInteractivePdpChat",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "BuyerChatLazy_viewer",
          "args": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": false,
      "condition": "isInteractivePdpChat",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpRespDealerChatLazy_viewer",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = 'd1e3de8851dbdc78e309bf101b191fae';
export default node;
